import React from "react";
import SectionHeader from "../SectionHeader/SectionHeader";
import Tech from "../Tech/Tech";
import Education from "../Education/Education";
import useReveal from "../../useReveal";

export default function Skills() {
  const ref = useReveal();

  return (
    <section
      id="skills"
      ref={ref}
      style={{
        maxWidth: "var(--maxw)",
        margin: "0 auto",
        padding: "clamp(60px, 10vh, 120px) clamp(20px, 5vw, 48px)",
      }}
    >
      <SectionHeader index="03" kicker="systems & telemetry" title="Skills" />
      <Tech />
      <Education />
    </section>
  );
}
